import { object, string } from 'yup';

import { noDuplicateNamesSchema } from '../APICredentialsForm.validation';

export function validationSchema(names: string[]) {
  return object().shape({
    name: noDuplicateNamesSchema(names),
    credentials: object()
      .shape({
        username: string().required('Username is required.'),
        personalAccessToken: string().required(
          'Personal access token is required.'
        ),
      })
      .required(),
  });
}
